import { Box, Typography } from "@mui/material";
import { FC } from "react";

export interface Testimonial {
  quote: string;
  name: string;
  designation: string;
}

export interface TestimonialCardProps {
  testimonial: Testimonial;
}

export const TestimonialCard: FC<TestimonialCardProps> = ({ testimonial }) => (
  <Box
    sx={{
      bgcolor: "#fff",
      borderRadius: '6px',
      p: '24px',
      width: "100%",
      maxWidth: 648,
      minWidth: 0,
      mx: "auto",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
      flex: "0 0 100%",
      overflow: "hidden",
    }}
  >
    <Typography
      variant="body1"
      sx={{
        mb: 3,
        display: "block",
        whiteSpace: "normal",
        fontSize: { xs: '16px', md: '18px' },
        color: '#111827',
        fontStyle: 'italic'
      }}
    >
      “{testimonial.quote}”
    </Typography>
    <Typography variant="body1" sx={{ mb: '4px', color: '#111827', fontSize: { xs: '14px', md: '14px' } }}>
      {testimonial.name}
    </Typography>
    <Typography variant="body1" sx={{ color: '#6B7280', fontSize: { xs: '14px', md: '14px' } }}>
      {testimonial.designation}
    </Typography>
  </Box>
); 
